<div class="roadmap-card">
  <div class="roadmap-header" [class.roadmap-header--draggable]="!section.isDefault" cdkDragHandle>
    @if (!section.isDefault) {
      <pdq-drag-and-drop size="small"></pdq-drag-and-drop>
    }
    @if (isEditing) {
      <pdq-input
        class="section-name-input"
        size="small"
        [control]="editNameControl"
        [autofocus]="true"
        (blur)="finishEditing()"
        (keydown)="onKeydown($event)">
      </pdq-input>
    } @else {
      <div class="section-name" (dblclick)="startEditing()">
        <pdq-heading element="h6">{{ section.name }} ({{ strategies.length }})</pdq-heading>
        @if (!section.isDefault) {
          <pdq-button icon="edit" variant="ghost" size="small" [plain]="true" (onClick)="startEditing()"> </pdq-button>
        }
      </div>
    }
    @if (!section.isDefault) {
      <pdq-button icon="delete" variant="ghost" size="small" (onClick)="sectionDeleted.emit(section.id)"> </pdq-button>
    }
  </div>

  <div
    class="roadmap-list"
    cdkDropList
    [id]="dropListId"
    [cdkDropListData]="{ sectionId: section.id, strategies: strategies }"
    [cdkDropListConnectedTo]="connectedDropLists"
    [cdkDropListEnterPredicate]="strategyDropPredicate"
    (cdkDropListDropped)="onDrop($event)">
    @for (item of strategies; track item[StrategyColumns.ID]; let i = $index) {
      <div class="roadmap-row" cdkDrag>
        <pdq-drag-and-drop></pdq-drag-and-drop>

        <p class="roadmap-row__category" [ngClass]="optimizeCategoryName(item)">
          {{ item[StrategyColumns.PRIMARY_CATEGORY] }}
        </p>
        @if (item.isCustom) {
          <span class="roadmap-row__custom-badge">Custom</span>
        }

        <span class="roadmap-row__name" (click)="strategyClicked.emit(item)">{{ item[StrategyColumns.NAME] }}</span>

        <div class="roadmap-row__actions">
          @if (item.parsedKpiTargets.length > 0) {
            <span class="roadmap-row__kpi">{{ item.parsedKpiTargets[0] }}</span>
          }

          @if (connectedTestMap.get(item[StrategyColumns.ID]); as test) {
            @if (test.status) {
              <span class="roadmap-row__test-badge test-badge--{{ test.status }}">
                {{ test.status }}
              </span>
            }
          }

          @if (commentCountMap.get(item[StrategyColumns.ID]) > 0 || hasNotesMap.get(item[StrategyColumns.ID])) {
            <pdq-icon icon="internal_note" color="var(--on-surface-light)" size="small"></pdq-icon>
          }

          <pdq-button
            icon="minus-circle"
            variant="ghost"
            size="small"
            matTooltip="Remove"
            matTooltipPosition="above"
            matTooltipClass="pdq-mat-tooltip"
            (onClick)="removeStrategy(i)">
          </pdq-button>
        </div>
      </div>
    }

    @if (strategies.length === 0) {
      <div class="roadmap-row roadmap-row--empty">
        <p class="empty-section-text">Drag strategies here</p>
      </div>
    }
  </div>
</div>
